<div class="migrations">
  <h1 class="migrations__title">Міграції</h1>

  <mat-card class="migrations__card">
    <mat-card-header>
      <mat-card-title>Запуск міграцій бази даних</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="migrations__buttons">
        @for (migration of migrations; track migration.code) {
          <button mat-raised-button color="primary" (click)="runMigration(migration.code)">
            {{ migration.label }}
          </button>
        }
      </div>

      @let executed = executedMigrations();
      @if (executed !== null) {
        <div class="migrations__result">
          @if (executed.length > 0) {
            <h3>Виконані міграції:</h3>
            @for (migration of executed; track migration) {
              <p>{{ migration }}</p>
            }
          } @else {
            <p>Нових міграцій немає.</p>
          }
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
